import React from "react";
import { Button } from "react-bootstrap";
import { CSSTransition, TransitionGroup } from "react-transition-group-v2";
import "../Animation.css";
import styles from "./Project.module.scss";
const Project = props => {
  return (
    <TransitionGroup className={styles.Project}>
      <CSSTransition
        key={props.title}
        timeout={600}
        classNames="fade"
        appear={true}
      >
        <div className={styles.card}>
          <h4 className={styles.title}>{props.title}</h4>
          <p className={styles.description}>{props.description}</p>
          <div className={styles.buttons}>
            <Button href={props.live} target="_blank" className={styles.dark}>
              Live Demo
            </Button>
            <Button
              href={props.git}
              target="_blank"
              className={styles.outlineDark}
            >
              Github
            </Button>
          </div>
        </div>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Project;
